import { useEffect, useMemo, useState } from "react";

const PROMO_COIN_ICON = "/assets/coin/coin12.webp";
const PROMO_GEM_ICON = "/assets/gem/diamond_6.webp";

const staticPerks = [
  {
    id: "exclusive",
    text: "WEB EXCLUSIVE",
    className:
      "self-start -rotate-6 border-[#ffe3a4] bg-[linear-gradient(180deg,#fff6d0_0%,#ffd76c_58%,#ffb13a_100%)] px-5 py-3 text-[#402100] shadow-[0_18px_30px_rgba(255,182,54,0.22)] dark:border-[#8b6a1d] dark:bg-[linear-gradient(180deg,rgba(255,215,110,0.28),rgba(255,180,57,0.14))] dark:text-goldSoft dark:shadow-[0_18px_30px_rgba(255,182,54,0.12)]",
    textClassName: "text-xs sm:text-sm tracking-[0.28em]",
  },
  {
    id: "coins",
    text: "UP TO 10% OFF",
    className:
      "self-center rotate-[2deg] border-[#ffd89f] bg-[linear-gradient(180deg,#fff6c8_0%,#ffd458_44%,#ff9825_100%)] px-6 py-4 text-[#4c2500] shadow-[0_22px_34px_rgba(255,161,46,0.28)] dark:border-[#8b6a1d] dark:bg-[linear-gradient(180deg,rgba(255,215,110,0.28),rgba(255,180,57,0.14))] dark:text-goldSoft dark:shadow-[0_22px_34px_rgba(255,161,46,0.16)]",
    textClassName: "text-[1.35rem] sm:text-[1.7rem] tracking-[-0.03em]",
  },
  {
    id: "inbox",
    text: "SYNCED INSTANTLY",
    className:
      "self-end rotate-[-3deg] border-[#cde8ff] bg-[linear-gradient(180deg,#f3fbff_0%,#d8f0ff_100%)] px-5 py-3 text-[#183760] shadow-[0_18px_30px_rgba(112,180,255,0.18)] dark:border-[#296589] dark:bg-[linear-gradient(180deg,rgba(80,196,255,0.13),rgba(80,196,255,0.05))] dark:text-sapphire dark:shadow-[0_18px_30px_rgba(112,180,255,0.1)]",
    textClassName: "text-sm sm:text-[1.05rem] tracking-[0.16em]",
  },
];

function TreasureChestArt() {
  return (
    <div className="relative h-32 w-32 sm:h-40 sm:w-40">
      <div className="absolute inset-x-4 bottom-0 h-5 rounded-full bg-[#8a4a11]/20 blur-lg" />
      <div className="absolute left-3 top-2 h-11 w-11 rounded-full bg-[#ffd66b]/50 blur-xl" />
      <div className="absolute right-4 top-4 h-9 w-9 rounded-full bg-[#ff86cb]/30 blur-lg" />
      <div className="absolute left-8 top-0 h-5 w-5 rounded-full border border-[#ffe8a8] bg-[linear-gradient(180deg,#fff7c6,#ffc73f)]" />
      <div className="absolute left-16 top-6 h-5 w-5 rounded-full border border-[#ffe8a8] bg-[linear-gradient(180deg,#fff7c6,#ffc73f)]" />
      <div className="absolute right-8 top-2 h-5 w-5 rounded-full border border-[#ffe8a8] bg-[linear-gradient(180deg,#fff7c6,#ffc73f)]" />
      <div className="absolute inset-x-5 top-8 h-10 rounded-t-[1.7rem] border-[3px] border-[#ffe09d] bg-[linear-gradient(180deg,#ffd86e_0%,#ffad36_100%)]" />
      <div className="absolute left-5 right-5 top-[4.65rem] h-[3.8rem] rounded-[1.3rem] border-[3px] border-[#ffd58b] bg-[linear-gradient(180deg,#d46f18_0%,#a74e0d_100%)]" />
      <div className="absolute left-[46%] top-[4.25rem] h-[4.7rem] w-[0.72rem] -translate-x-1/2 rounded-full bg-[linear-gradient(180deg,#fff1bc,#ffca56)] shadow-[0_0_0_3px_rgba(199,112,22,0.45)]" />
      <div className="absolute left-1/2 top-[5.45rem] h-8 w-8 -translate-x-1/2 rounded-[0.9rem] border-[3px] border-[#ffe09d] bg-[linear-gradient(180deg,#ffe081_0%,#ffbd3b_100%)]" />
      <div className="absolute left-1/2 top-[6rem] h-3 w-3 -translate-x-1/2 rounded-full bg-[#93510f]" />
    </div>
  );
}

function PromoVisual({ type }) {
  const isCoins = type === "coins";
  const isJewels = type === "jewels";

  if (!isCoins && !isJewels) {
    return (
      <div className="relative flex h-40 w-40 items-center justify-center rounded-[2rem] border border-[#f6d8a0] bg-[radial-gradient(circle_at_top,#fffdf1_0%,#fff2ce_48%,#ffd898_100%)] shadow-[0_24px_46px_rgba(255,183,62,0.22)] dark:border-[#8b6a1d] dark:bg-[radial-gradient(circle_at_top,rgba(255,215,110,0.2)_0%,rgba(255,180,57,0.12)_48%,rgba(120,60,10,0.18)_100%)] dark:shadow-[0_24px_46px_rgba(0,0,0,0.3)] sm:h-48 sm:w-48">
        <TreasureChestArt />
      </div>
    );
  }

  return (
    <div
      className={`relative flex h-40 w-40 items-center justify-center rounded-[2rem] border p-5 sm:h-48 sm:w-48 sm:p-6 ${
        isCoins
          ? "border-[#ffe1ac] bg-[radial-gradient(circle_at_top,#fffef6_0%,#fff1ca_48%,#ffd28f_100%)] shadow-[0_24px_46px_rgba(255,183,62,0.22)] dark:border-[#8b6a1d] dark:bg-[radial-gradient(circle_at_top,rgba(255,215,110,0.18)_0%,rgba(255,180,57,0.1)_48%,rgba(120,60,10,0.15)_100%)] dark:shadow-[0_24px_46px_rgba(0,0,0,0.3)]"
          : "border-[#caecff] bg-[radial-gradient(circle_at_top,#ffffff_0%,#eefbff_50%,#d7ecff_100%)] shadow-[0_24px_46px_rgba(108,180,255,0.2)] dark:border-[#296589] dark:bg-[radial-gradient(circle_at_top,rgba(80,196,255,0.15)_0%,rgba(80,196,255,0.08)_50%,rgba(30,60,120,0.15)_100%)] dark:shadow-[0_24px_46px_rgba(0,0,0,0.3)]"
      }`}
    >
      <div
        className={`absolute inset-4 rounded-[1.65rem] blur-2xl ${
          isCoins ? "bg-[#ffd167]/35 dark:bg-[#ffd167]/20" : "bg-[#7bdfff]/30 dark:bg-[#7bdfff]/15"
        }`}
      />
      <img
        src={isCoins ? PROMO_COIN_ICON : PROMO_GEM_ICON}
        alt={isCoins ? "Coins" : "Gems"}
        className={`relative z-10 object-contain drop-shadow-[0_14px_24px_rgba(0,0,0,0.18)] ${
          isCoins ? "h-28 w-28 sm:h-36 sm:w-36" : "h-30 w-30 sm:h-36 sm:w-36"
        }`}
      />
    </div>
  );
}

function getPromoContent(promo) {
  if (!promo) {
    return {
      tag: "DAILY RESTOCK",
      tagClassName: "text-[#7d4f0c] dark:text-goldSoft/70",
      title: "BEST VALUE EVERY DAY",
      titleClassName: "text-[#5d3a08] dark:text-goldSoft",
      subtitle: "STOCK UP YOUR STASH",
      type: "none",
    };
  }

  if (promo.type === "jewels") {
    const hasBonus = Number(promo.maxBonus) > 0;
    return {
      tag: "GEM RUSH",
      tagClassName: "text-[#2564c7] dark:text-sapphire/70",
      title: hasBonus ? `UP TO +${promo.maxBonus}% GEMS` : "GEM RUSH",
      titleClassName: "text-[#2552c6] dark:text-sapphire",
      subtitle: "BOOST YOUR GAME!",
      type: "jewels",
    };
  }

  const hasBonus = Number(promo.maxBonus) > 0;
  return {
    tag: "FLASH SALE",
    tagClassName: "text-[#dd4b59] dark:text-ruby",
    title: hasBonus ? `UP TO +${promo.maxBonus}% COINS` : "COIN RUSH",
    titleClassName: "text-[#d68b00] dark:text-gold",
    subtitle: "SPIN BIGGER TODAY!",
    type: "coins",
  };
}

export default function PromoBanner({
  coinMaxBonus = null,
  gemMaxBonus = null,
  coinPromoActive = false,
  gemPromoActive = false,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const maxCoinBonus = Number.isFinite(Number(coinMaxBonus)) ? Math.max(Number(coinMaxBonus), 0) : 0;
  const maxGemBonus = Number.isFinite(Number(gemMaxBonus)) ? Math.max(Number(gemMaxBonus), 0) : 0;

  // 轮播显示开关（用户规则）：
  // 仅由外部活动开关决定，不再按 maxBonus 自动推断，避免未开活动也显示轮播。
  const isCoinPromoEnabled = coinPromoActive === true;
  const isGemPromoEnabled = gemPromoActive === true;

  const activePromos = useMemo(() => {
    const promos = [];

    // 活动开启决定轮播项是否存在；加成数字只决定文案，避免跨天商品加成暂时为 0 时把活动过滤掉。
    if (isCoinPromoEnabled) {
      promos.push({
        id: 'coin-sale',
        type: "coins",
        maxBonus: maxCoinBonus
      });
    }

    if (isGemPromoEnabled) {
      promos.push({
        id: 'gem-sale',
        type: "jewels",
        maxBonus: maxGemBonus
      });
    }

    return promos;
  }, [isCoinPromoEnabled, isGemPromoEnabled, maxCoinBonus, maxGemBonus]);
  const activePromoKey = activePromos.map((promo) => `${promo.id}:${promo.maxBonus}`).join('|');

  useEffect(() => {
    setCurrentIndex(0);
  }, [activePromoKey]);

  useEffect(() => {
    if (activePromos.length <= 1) return undefined;

    const intervalId = window.setInterval(() => {
      setCurrentIndex((previous) => (previous + 1) % activePromos.length);
    }, 3000);

    return () => window.clearInterval(intervalId);
  }, [activePromos.length]);

  // 无活动场景也要展示默认 Banner（用户明确要求）：
  // - 当 activePromos 为空时，currentPromo 为 null；
  // - getPromoContent(null) 会返回默认文案与默认视觉（BEST VALUE EVERY DAY）。
  // 这里不做 return null，确保页面始终保留该区域。

  const currentPromo =
    activePromos.length > 0 ? activePromos[currentIndex % activePromos.length] : null;
  const promoContent = getPromoContent(currentPromo);
  const dotCount = activePromos.length;

  return (
    <section className="relative overflow-hidden rounded-[2.4rem] border border-[#dbe4ff] bg-[linear-gradient(135deg,#ffffff_0%,#edf6ff_38%,#fff4df_100%)] p-4 shadow-[0_28px_72px_rgba(90,113,194,0.12)] dark:border-white/10 dark:bg-[linear-gradient(135deg,rgba(20,10,40,0.9)_0%,rgba(15,8,35,0.95)_38%,rgba(25,15,30,0.9)_100%)] dark:shadow-[0_28px_72px_rgba(0,0,0,0.3)] sm:p-5">
      <div className="absolute -left-14 top-0 h-28 w-28 rounded-full bg-[#bdd8ff]/45 blur-3xl dark:bg-gold/10" />
      <div className="absolute right-[-10px] top-[-14px] h-32 w-32 rounded-full bg-[#ffe2aa]/55 blur-3xl dark:bg-gold/15" />
      <div className="absolute bottom-[-10px] left-1/3 h-24 w-24 rounded-full bg-[#dcc0ff]/35 blur-3xl dark:bg-[#8b35ff]/15" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.9),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(122,168,255,0.18),transparent_24%)] dark:bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.05),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(80,196,255,0.08),transparent_24%)]" />

      <div className="relative z-10 flex flex-col gap-4 md:flex-row md:items-stretch">
        <div className="md:basis-[40%]">
          <div className="flex h-full flex-col justify-center gap-3 sm:gap-4">
            {staticPerks.map((perk) => (
              <div
                key={perk.id}
                className={`rounded-full border-[2px] ${perk.className}`}
              >
                <p className={`font-display font-black uppercase leading-none ${perk.textClassName}`}>
                  {perk.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="md:basis-[60%]">
          <article className="relative h-full min-h-[18rem] overflow-hidden rounded-[2rem] border border-[#e2ebff] bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(248,250,255,0.94))] p-4 shadow-[0_26px_60px_rgba(88,109,192,0.14)] dark:border-white/10 dark:bg-[linear-gradient(180deg,rgba(255,255,255,0.06),rgba(255,255,255,0.02))] dark:shadow-[0_26px_60px_rgba(0,0,0,0.2)] sm:p-5">
            <div className="absolute inset-x-6 top-0 h-9 rounded-b-full bg-white/90 blur-md dark:bg-white/5" />
            <div
              key={currentPromo ? currentPromo.id : "empty"}
              className="relative z-10 flex h-full flex-col animate-modalIn"
            >
              <div className="flex items-start gap-3">
                <div className="min-w-0 flex-1 pt-1">
                  <p className={`text-[11px] font-black uppercase tracking-[0.32em] ${promoContent.tagClassName}`}>
                    {promoContent.tag}
                  </p>
                  <h3 className={`mt-3 max-w-[11ch] font-display text-[2.45rem] font-black uppercase leading-[0.84] tracking-[-0.05em] ${promoContent.titleClassName} sm:text-[3.2rem] xl:text-[3.7rem]`}>
                    {promoContent.title}
                  </h3>
                  <p className="mt-3 font-display text-[1rem] font-black uppercase tracking-[0.03em] text-[#757f95] dark:text-textSecondary sm:text-[1.15rem]">
                    {promoContent.subtitle}
                  </p>
                </div>

                <div className="shrink-0">
                  <PromoVisual type={promoContent.type} />
                </div>
              </div>

              {dotCount > 1 ? (
                <div className="mt-auto flex items-center gap-2 pt-4">
                  {activePromos.map((promo, index) => (
                    <span
                      key={promo.id}
                      className={`h-2.5 rounded-full transition-all duration-300 ${
                        index === currentIndex
                          ? "w-10 bg-[#5965ef] dark:bg-gold"
                          : "w-2.5 bg-[#c6cff2] dark:bg-white/20"
                      }`}
                    />
                  ))}
                </div>
              ) : null}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
